import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import {
  clearImpersonationToken,
  isImpersonating,
} from "@/utils/impersonation";

/**
 * Banner shown when admin is impersonating an organization
 */
export const ImpersonationBanner = () => {
  const router = useRouter();
  const impersonating = isImpersonating();

  if (!impersonating) {
    return null;
  }

  const handleExitImpersonation = () => {
    clearImpersonationToken();
    // Reload to clear Apollo cache and get fresh data
    router.reload();
  };

  return (
    <Box
      bg="orange.400"
      color="white"
      px={4}
      py={1.5}
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={99999}
      boxShadow="sm"
      borderBottom="1px solid"
      borderColor="orange.600"
    >
      <Flex justify="space-between" align="center" maxW="100%" mx="auto" h="32px">
        <Flex align="center" gap={2}>
          <Text fontSize="xs" fontWeight="semibold">
            ⚠️ Admin režim
          </Text>
          <Text fontSize="xs" opacity={0.9}>
            Prihlásený ako iná organizácia
          </Text>
        </Flex>
        <Button
          size="xs"
          colorScheme="whiteAlpha"
          variant="solid"
          onClick={handleExitImpersonation}
          fontSize="xs"
          h="24px"
        >
          Ukončiť
        </Button>
      </Flex>
    </Box>
  );
};
